export interface Anchor {
    draw(context: CanvasRenderingContext2D, x: number, y: number): void;
}
